import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OfflineHelpersService } from '@asm/features/sync/interceptor/offline-helpers.service';

/**
 * Handler offline para endpoints relacionados à unidade B2B do usuário.
 * Cobre: GET /b2b-unit/me
 */
@Injectable({ providedIn: 'root' })
export class B2BUnitOfflineHandler {
  private readonly ctx = inject(OfflineHelpersService);

  canHandle(req: HttpRequest<unknown>): boolean {
    return req.method === 'GET' && req.url.includes('/b2b-unit/me');
  }

  async handle(req: HttpRequest<unknown>): Promise<HttpResponse<unknown>> {
    const stored = await this.ctx.readStoredB2BUnitDetails();
    return new HttpResponse({ status: 200, body: stored ?? {} });
  }
}
